import React from 'react';
import VoucherPage from './VoucherPage';

const DomainsPage: React.FC = () => {
  return <VoucherPage category="domains" />;
};

export default DomainsPage;

